import { render } from "./Notes-list-item.vue?vue&type=template&id=6df4175a&scoped=true&lang=pug"
import script from "./Notes-list-item.vue?vue&type=script&setup=true&lang=js"
export * from "./Notes-list-item.vue?vue&type=script&setup=true&lang=js"

import "./Notes-list-item.vue?vue&type=style&index=0&id=6df4175a&scoped=true&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6df4175a"]])

export default __exports__